/**
 * MainBannerPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */

import React from 'react';

import { Content } from './styledComponents';

export default function MainBanner() {
  return (
    <Content>
      <div className="vertical"></div>
    </Content>
  );
}
